module.exports = __webpack_public_path__ + "img/serve4.1ebcd770.png";